import { type PermissionRouteData, PermissionRoute } from '@exam-management/permission-route';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';

export default function QConfigDetailsRouteController() {
  const { courseId, qconfigId } = useParams('/exam-courses/:courseId/qconfigs/:qconfigId');

  const defaultRoutes: PermissionRouteData[] = [
    {
      path: '/exam-courses/:courseId/qconfigs/:qconfigId/details',
      requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
      params: {
        courseId,
        qconfigId,
      },
    },
    {
      path: '/exam-courses/:courseId/qconfigs/:qconfigId/settings',
      requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
      params: {
        courseId,
        qconfigId,
      },
    },
    {
      path: '/exam-courses/:courseId/qconfigs/:qconfigId/activity-log',
      requiredPermission: [APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
      params: {
        courseId,
        qconfigId,
      },
    },
  ];

  return <PermissionRoute routes={defaultRoutes} />;
}
